'use client';

import { useState, useEffect } from 'react';
import Header from '@/components/common/Header';
import ClinicalEvidenceQuickAccess from '@/components/common/ClinicalEvidenceQuickAccess';
import DemoRequestSticky from '@/components/common/DemoRequestSticky';
import TrustIndicatorBar from '@/components/common/TrustIndicatorBar';
import IntroSection from './IntroSection';
import HeroSection from './HeroSection';
import ProblemStatement from './ProblemStatement';
import SolutionOverview from './SolutionOverview';
import KeyBenefits from './KeyBenefits';
import SocialProof from './SocialProof';
import TeamSection from './TeamSection';
import OurStory from './OurStory';
import ClinicalEvidence from './ClinicalEvidence';
import ProductSpecifications from './ProductSpecifications';
import PricingProcurement from './PricingProcurement';
import FAQ from './FAQ';
import FinalConversion from './FinalConversion';
import Footer from './Footer';
import PartnersRibbon from './PartnersRibbon';

const LandingPageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleDownloadEvidence = () => {
    console.log('Downloading clinical evidence package');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <TrustIndicatorBar />
      <ClinicalEvidenceQuickAccess />
      <DemoRequestSticky />

      <main>
        <IntroSection />
        <HeroSection onDownloadEvidence={handleDownloadEvidence} />

        <OurStory />
        <PartnersRibbon />
        <ProblemStatement />
        <SolutionOverview />
        <KeyBenefits />
        <SocialProof />
        <TeamSection />

        <ClinicalEvidence />
        <ProductSpecifications />
        <PricingProcurement />
        <FAQ />
        <FinalConversion />
      </main>

      <Footer />
    </div>
  );
};

export default LandingPageInteractive;